import type {Rec} from 'src/typings';
import type {ToastMessageService} from 'shared/components/kp-toast-messages';
import type {LocalizationService} from 'shared/providers';
import type {RecordClipboardService} from '../record-clipboard.service';
import type {Observable} from 'rxjs';

export class KpRecordClipboardButtonPresenter {
    public static presenterName = 'kpRecordClipboardButtonPresenter';

    /*@ngInject*/
    constructor(private recordClipboardService: RecordClipboardService,
                private toastMessageService: ToastMessageService,
                private localizationService: LocalizationService) {
    }

    public getRecords$(): Observable<Rec[]> {
        return this.recordClipboardService.getRecords$();
    }

    public addRecord(record: Rec) {
        this.recordClipboardService.add(record);
        this.toastMessageService.showInfo(this.localizationService.get(/* @kp-localization commons.Marked */ 'commons.Marked'));
    }

    public removeRecord(record: Rec) {
        this.recordClipboardService.remove(record);
        this.toastMessageService.showInfo(this.localizationService.get(/* @kp-localization commons.Demarked */ 'commons.Demarked'));
    }

    public canAddToClipboard(record: Rec): boolean {
        return !this.recordClipboardService.contains(record);
    }

    public canRemoveToClipboard(record: Rec): boolean {
        return this.recordClipboardService.contains(record);
    }
}